import { Component } from '@angular/core';

@Component({
    template: require('./forgot-password.component.html')
})

export class ForgotPasswordComponent{
}